module.exports = __webpack_public_path__ + "static/icon-holiday.eb4b8c88.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-holiday.png
// module id = 288
// module chunks = 2